export const AUTH_ERROR = 'AUTH_ERROR';
export const UNEXPECTED_ERROR = 'UNEXPECTED_ERROR';



// WEBPACK FOOTER //
// ./src/commons/services/errorCodes.js